module.exports = __webpack_public_path__ + "static/media/KDR-WHITE.4c4916c1.png";